"use client";

import React, { useEffect, useRef, useState } from "react";
import "./WalkthroughSection.css";

export default function WalkthroughSection({ projectDetail }) {
  const sectionRef = useRef(null);
  const videoRef = useRef(null);
  const [active, setActive] = useState(false);

  const hasAnimated = useRef(false);

  const isNbPalm = String(projectDetail?.project_id) === "880";

  const videoSrc = isNbPalm
    ? "/images/nb-palm/walkthrough.mp4"
    : projectDetail?.virtual_data?.find((item) => item.type === "walk-through")
        ?.url;

  useEffect(() => {
    if (!sectionRef.current || !videoRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = entry.isIntersecting;

        /* animation only once */

        if (visible && !hasAnimated.current) {
          setActive(true);

          hasAnimated.current = true;
        }

        /* video behavior */

        if (visible) {
          videoRef.current.play().catch(() => {});
        } else {
          videoRef.current.pause();
        }
      },
      {
        threshold: 0.45,
      },
    );

    observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  if (!videoSrc) return null;

  return (
    <section
      ref={sectionRef}
      className={`walkthrough-section ${active ? "walkthrough-active" : ""}`}
    >
      <div className="">
        <div className="walkthrough-wrapper">
          <div className="walkthrough-video-box">
            <video
              ref={videoRef}
              muted
              loop
              playsInline
              preload="metadata"
              controls={false}
            >
              <source src={videoSrc} />
            </video>
          </div>
        </div>
      </div>
    </section>
  );
}
